export class PreconditionError extends Error {
  constructor(message, _data) {
    super(message)
    const { code = 412, ...data } = _data ?? {}
    this.code = code
    this.data = data
    this.name = 'PreconditionError'
    Object.setPrototypeOf(this, PreconditionError.prototype)
  }
}

export class VerificationError extends PreconditionError {
  constructor(message, _data) {
    const { code = 500, ...data } = _data ?? {}
    super(message, { code, ...data})
    this.name = 'VerificationError'
    Object.setPrototypeOf(this, VerificationError.prototype)
  }
}
